@if (!isOnlyHover) {
    <div class="form-group mb-20">
        <label class="col-xs-10 control-label text-left">
            {{ "control_text_color" | translate }}
        </label>
        <div class="col-xs-2">
            <sp-color-picker
                hideGradient
                [color]="colorValue"
                [colorsPreset]="colorsPreset"
                (colorChangeEvent)="setColor($event)"
            />
        </div>
    </div>
    <div class="form-group mb-20">
        <label class="col-xs-10 control-label text-left">
            {{ "control_background_color" | translate }}
        </label>
        <div class="col-xs-2">
            <sp-color-picker
                [color]="backgroundValue"
                [colorsPreset]="colorsPreset"
                (colorChangeEvent)="setBackground($event)"
            />
        </div>
    </div>
    @if (isThemeSettings && isWebsiteThemeButton) {
        <div class="form-group mb-20">
            <label class="col-xs-12">
                {{ "control_contour" | translate }}
            </label>
            <div class="col-xs-4">
                <sp-input-num
                    suffixText="px"
                    [min]="BORDER_WIDTH_MIN"
                    [max]="BORDER_WIDTH_MAX"
                    [onlyIntegers]="true"
                    [value]="borderWidth.value"
                    (valueChange)="setBorderWidth($event)"
                    (blurEvent)="setBorderWidth($event)"
                />
            </div>
            <div class="col-xs-6 custom-corner-wrapper">
                <div
                    class="disabled-btn-wrapper"
                    [tooltip]="'control_custom_radius_toolip_disabled' | translate"
                    placement="top"
                >
                    <button class="btn btn-action btn-custom-corner disabled">
                        <img src="./assets/img/websites/lpc-corner-icon.svg" />
                    </button>
                </div>
                <sp-input-num
                    class="custom-corner-input"
                    suffixText="px"
                    [min]="BORDER_RADIUS_MIN"
                    [max]="BORDER_RADIUS_MAX"
                    [onlyIntegers]="true"
                    [value]="borderRadius.value"
                    (valueChange)="setBorderRadius($event)"
                    (blurEvent)="setBorderRadius($event)"
                />
            </div>
            <div class="col-xs-2">
                <sp-color-picker
                    hideGradient
                    [positionLeft]="true"
                    [color]="borderColorValue"
                    [colorsPreset]="colorsPreset"
                    (colorChangeEvent)="setBorderColor($event)"
                />
            </div>
        </div>
    }
    @if (!(isThemeSettings && isWebsiteThemeButton)) {
        @if (!isAdvancedRadius) {
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_contour" | translate }}
                </label>
                <div class="col-xs-4">
                    <sp-input-num
                        suffixText="px"
                        [min]="BORDER_WIDTH_MIN"
                        [max]="BORDER_WIDTH_MAX"
                        [onlyIntegers]="true"
                        [value]="borderWidth.value"
                        (valueChange)="setBorderWidth($event)"
                        (blurEvent)="setBorderWidth($event)"
                    />
                </div>
                <div class="col-xs-6">
                    <sp-input-num
                        prefixImgUrl="./assets/img/border-radius-icon.svg"
                        suffixText="px"
                        [min]="BORDER_RADIUS_MIN"
                        [max]="BORDER_RADIUS_MAX"
                        [onlyIntegers]="true"
                        [value]="borderRadius.value"
                        (valueChange)="setBorderRadius($event)"
                        (blurEvent)="setBorderRadius($event)"
                    />
                </div>
                <div class="col-xs-2">
                    <sp-color-picker
                        hideGradient
                        [positionLeft]="true"
                        [color]="borderColorValue"
                        [colorsPreset]="colorsPreset"
                        (colorChangeEvent)="setBorderColor($event)"
                    />
                </div>
            </div>
        }
        @if (isAdvancedRadius) {
            <div
                class="form-group"
                [class.mb-10]="isIndependentCornersValue.value"
                [class.mb-20]="!isIndependentCornersValue.value"
            >
                <label class="col-xs-6 control-label">
                    {{ "control_radius" | translate }}
                </label>
                <div class="col-xs-6 custom-corner-wrapper">
                    <button
                        [tooltip]="'control_custom_radius_toolip' | translate"
                        placement="top"
                        class="btn btn-action btn-custom-corner"
                        [class.active]="isIndependentCornersValue.value"
                        (click)="toggleIndenpendentCorners()"
                    >
                        <img src="./assets/img/websites/lpc-corner-icon.svg" />
                    </button>
                    <!-- placeholder to mix corners -->
                    @if (isIndependentCornersValue.value) {
                        <div class="custom-corner-input">
                            <div class="input-group">
                                <input class="form-control" value="Mix" disabled />
                                <div class="input-group-addon">px</div>
                            </div>
                        </div>
                    }
                    <!-- placeholder to mix corners end -->
                    @if (!isIndependentCornersValue.value) {
                        <sp-input-num
                            class="custom-corner-input"
                            suffixText="px"
                            [min]="BORDER_RADIUS_MIN"
                            [max]="BORDER_RADIUS_MAX"
                            [value]="borderTopLeftRadius.value"
                            (valueChange)="setBorderRadius($event)"
                        />
                    }
                </div>
            </div>
        }
    }
    @if (isIndependentCornersValue.value) {
        <div class="mb-20">
            <sp-advanced-radius-settings
                [radiusSettings]="radiusSettings"
                (valueChangeEvent)="setAdvancedRadiusSettings($event)"
            />
        </div>
    }
    @if (isAdvancedRadius) {
        <div class="mb-20">
            <div class="form-group mb-5">
                <label class="col-xs-12 control-label">
                    {{ "control_contour" | translate }}
                </label>
            </div>
            <sp-advanced-border-settings
                [borderSettings]="advancedBorderSettingsValue"
                (valueChangeEvent)="setAdvancedBorderSettings($event)"
            />
        </div>
    }
}
@if (showHoverSettings) {
    <div class="form-group">
        <label class="col-xs-12">
            {{ "control_hover_effect" | translate }}
        </label>
        <div
            [class.col-xs-8]="hoverType.value === EButtonHoverType.opacity"
            [class.col-xs-12]="hoverType.value !== EButtonHoverType.opacity"
        >
            <select class="form-control" (change)="changeHoverOptions($event)">
                @for (option of buttonHoverOptions; track option) {
                    <option [value]="option.value" [selected]="option.value === hoverType.value">
                        {{ option.label | translate }}
                    </option>
                }
            </select>
        </div>
        @if (hoverType.value === EButtonHoverType.opacity) {
            <div class="col-xs-4">
                <sp-input-num
                    suffixText="%"
                    [min]="OPACITY_MIN"
                    [max]="OPACITY_MAX"
                    [value]="opacity.value"
                    (valueChange)="setOpacity($event)"
                    (blurEvent)="setOpacity($event)"
                ></sp-input-num>
            </div>
        }
    </div>
    @if (hoverType.value === EButtonHoverType.color) {
        <div class="alternative-color-settings">
            <div class="form-group mb-10">
                <label class="col-xs-9 control-label">
                    {{ "control_text_color" | translate }}
                </label>
                <div class="col-xs-3">
                    <sp-color-picker
                        hideGradient
                        [color]="hoverColorValue"
                        [colorsPreset]="colorsPreset"
                        (colorChangeEvent)="setHoverColor($event)"
                    />
                </div>
            </div>
            <div class="form-group mb-10">
                <label class="col-xs-9 control-label">
                    {{ "control_background_color" | translate }}
                </label>
                <div class="col-xs-3">
                    <sp-color-picker
                        hideGradient
                        [color]="hoverBackgroundValue"
                        [colorsPreset]="colorsPreset"
                        (colorChangeEvent)="setHoverBackground($event)"
                    />
                </div>
            </div>
            <div class="form-group">
                <label class="col-xs-9 control-label">
                    {{ "control_contour_color" | translate }}
                </label>
                <div class="col-xs-3">
                    <sp-color-picker
                        hideGradient
                        [color]="hoverBorderColorValue"
                        [colorsPreset]="colorsPreset"
                        (colorChangeEvent)="setHoverBorderColor($event)"
                    />
                </div>
            </div>
        </div>
    }
}
